import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScreenService {
  private readonly SIZE_SM: number = 576;
  private readonly SIZE_MD: number = 768;
  private readonly SIZE_LG: number = 992;
  public isMobile: boolean;
  public isMobile$: Subject<boolean>;
  public isSmallScreen: boolean;
  public isSmallScreen$: Subject<boolean>;

  constructor() {
    this.isMobile = window.innerWidth <= this.SIZE_LG;
    this.isSmallScreen = window.innerWidth <= this.SIZE_SM;
    this.isMobile$ = new Subject();
    this.isSmallScreen$ = new Subject();
    this.isMobile$.next(this.isMobile);
    this.isSmallScreen$.next(this.isSmallScreen);

    window.addEventListener(
      'resize',
      event => {
        const nextIsMobile = window.innerWidth <= this.SIZE_LG;
        const nextIsSmallScreen = window.innerWidth <= this.SIZE_SM;

        if (this.isMobile !== nextIsMobile) {
          this.isMobile = nextIsMobile;
          this.isMobile$.next(this.isMobile);
        }

        if (this.isSmallScreen !== nextIsSmallScreen) {
          this.isSmallScreen = nextIsSmallScreen;
          this.isSmallScreen$.next(this.isSmallScreen);
        }
      },
      true
    );
  }
}
